import React from 'react';
import { BooleanInput, required, SelectInput, TextInput, useTranslate } from 'react-admin';

const label = (key: string) => `resources.legalConsents.fields.${key}`;

interface LegalConsentFormProps {
  edit?: boolean;
}

const LegalConsentForm = (props: LegalConsentFormProps) => {
  const { edit } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(label(key));

  return (
    <>
      <TextInput source='type' label={t('type')} fullWidth validate={required()} disabled={edit} />
      <TextInput
        source='version'
        label={t('version')}
        fullWidth
        validate={required()}
        disabled={edit}
      />
      <TextInput source='requestTitle' label={t('requestTitle')} fullWidth validate={required()} />
      <TextInput
        source='requestBody'
        label={t('requestBody')}
        fullWidth
        validate={required()}
        multiline
        rows={3}
      />
      <TextInput source='url' label={t('url')} fullWidth validate={required()} />
      <BooleanInput source='mandatory' label={t('mandatory')} defaultValue={true} />
      <SelectInput
        source='validityType'
        label={t('validityType')}
        fullWidth
        validate={required()}
        defaultValue='INFINITE'
        choices={[
          { id: 'INFINITE', name: t('INFINITE') },
          { id: 'ONE_TIME', name: t('ONE_TIME'), disabled: true },
          { id: 'DURATION', name: t('DURATION'), disabled: true },
        ]}
      />
    </>
  );
};

export default LegalConsentForm;
